import { forwardRef, type InputHTMLAttributes } from 'react';

import { cn } from '../../lib/utils';

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, type = 'text', ...props },
  ref,
) {
  return (
    <input
      type={type}
      ref={ref}
      className={cn(
        'border-silver-primary bg-bg-primary text-text-primary placeholder:text-text-tertiary h-9 w-full rounded-sm border px-3 text-sm',
        'focus:border-accent-primary focus:ring-2 focus:ring-[rgba(10,37,64,0.5)] focus:outline-none',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  );
});
